//
class DownloadManager {
    constructor(parent, data) {
        this.parent = parent
        this.data = data
        this.init()
    }
    init() {
        document.querySelectorAll('[data-download]').forEach((el) => new DownloadManagerItem(el, this))
    }
}

class DownloadManagerItem {
    constructor(item, parent) {
        this.item = item
        this.parent = parent
        this.init()
    }
    init() {
        const url = this.item.dataset.download;
        const filename = this.item.dataset.downloadFilename;

        this.item.addEventListener('click', (event) => {
            event.preventDefault();
            event.stopPropagation();

            // Fetch the content of the file
            fetch(url)
                .then(response => response.blob())
                .then(blob => {
                    // Create an invisible anchor element
                    const a = document.createElement('a');
                    a.style.display = 'none';
                    document.body.appendChild(a);

                    // Create a URL for the Blob and set it as the href of the anchor
                    const url = window.URL.createObjectURL(blob);
                    a.href = url;
                    a.download = filename;
                    a.click();

                    // Clean up after ourselves
                    window.URL.revokeObjectURL(url);
                    document.body.removeChild(a);
                })
                .catch((error) => {
                    console.log("Error:" + error);
                });
        }, false);
    }
}

export default DownloadManager